import React, {memo} from 'react';
import {
    CONTROL_TYPE_ID_DIMMER,
    CONTROL_TYPE_ID_THERMOSTAT,
    ControlModel,
    ControlTypeModel,
    ThreePhaseSet,
} from '../../types/control';
import {useSelector} from 'react-redux';
import {SimpleControl} from '../SimpleControl';
import {ThreePhaseControl} from '../ThreePhaseControl';
import {DimmerControl} from '../Controls/DimmerControl';
import {TemperatureControl} from '../Controls/TemperatureControl';

const renderById = (control: ControlModel, controlType: ControlTypeModel<unknown>) => {
    switch (control.type_id) {
        case CONTROL_TYPE_ID_DIMMER: {
            return (
                <DimmerControl
                    controlType={controlType as ControlTypeModel}
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }

        case CONTROL_TYPE_ID_THERMOSTAT: {
            return (
                <TemperatureControl
                    key={`control_${control.id}`}
                    control={control}/>
            );
        }
    }

    return null;
};

export const Control = memo(function Item({control}: { control: ControlModel }) {
    const controlType = useSelector(
        state => state.control.controlTypeList.find(t => t.id === control?.type_id),
    );

    if (controlType == null) {
        return null;
    }

    if (controlType.render_type === 'simple' || controlType.render_type === 'pulse') {
        return (
            <SimpleControl
                control={control}
                controlType={controlType as ControlTypeModel}/>
        );
    }

    if (controlType.render_type === 'three_phase'||controlType.render_type === 'two_phase') {
        return (
            <ThreePhaseControl
                controlType={controlType as ControlTypeModel<ThreePhaseSet>}
                control={control}
            />
        );
    }

    return renderById(control, controlType);
});
